

















































import { Vue, Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import CONFIG from '@/common/config';
import getUrlParam from '@/common/utils/getUrlParam';
import throttle from '@/common/utils/throttle';
import { setObserver } from '@/common/utils/setObserver';
import { DECIMAL_MIN_NUM, DECIMAL_MAX_NUM } from '@/common/constants/index';
import fetch from '@/common/api/fetch';
import { Tip } from '@/common/interface';
import { majorNoticeText } from '@/common/constants/index';

import Radio from '@/components/common/edit/Radio.vue';
import Tips from '@/components/common/index/Tips.vue';
import ActivitySwitch from '@/components/common/edit/ActivitySwitch.vue';

interface Payload {
  status?: boolean;
  number?: number;
}

const lessonTips = {
  title: '微传单支付功能说明',
  content: `
        <p>1、使用线上支付会收取<span style="color: #FF6152">0.63%</span>的服务费</p>
        <p>2、活动发布后，不可修改支付模式和支付金额</p>
        <p>3、支付模式</p>
        <p>全额：家长直接按全额金额支付，无需再额外支付费用。</p>
        <p>定金：家长按定金金额支付，再通过线下补齐差额（定金金额需低于全额金额）</p>
        <p>4、家长支付完成后，视为购买课程成功，达到课程数量限制后，未支付的家长将无法再支付购买<p>
        <p>5、家长支付的金额，可在【小麦秀钱包】中查看和提现</p>
      `,
  newContent: `
        <p>1、使用线上支付会收取<span style="color: #FF6152">0.63%</span>的服务费</p>
        <p>2、活动发布后，不可修改支付模式和支付金额</p>
        <p>3、支付模式</p>
        <p>全额：家长直接按全额金额支付，无需再额外支付费用。</p>
        <p>定金：家长按定金金额支付，再通过线下补齐差额（定金金额需低于全额金额）</p>
        <p>4、家长支付完成后，视为购买课程成功，达到课程数量限制后，未支付的家长将无法再支付购买<p>
        <p>5、家长支付的金额，可在【小麦收银】中查看和提现</p>
      `,
};

@Component({
  components: {
    'activity-switch': ActivitySwitch,
    'activity-radio': Radio,
    tips: Tips,
  },
})
export default class PayEdit extends Vue {
  @Getter('canPay') canPay!: boolean;
  @Getter('payType') payType!: number;
  @Getter('payNumber') getterPayNumber!: number;
  @Getter('section') section!: object;
  @Getter('xcxFlag') xcxFlag!: boolean;
  @Getter('xmMajordomo') xmMajordomo!: boolean;
  @Getter('showPayEditModal') showPayEditModal!: boolean;
  @Getter('xcxType') xcxType!: string;
  // @Getter('wechatMiniOnlineStatus') wechatMiniOnlineStatus!: string;
  // @Getter('xmPayRegisterStatusEnum') xmPayRegisterStatusEnum!: string;
  @Getter('channel') channel: any;
  @Getter('releaseStatus') releaseStatus: any;

  @Action('switchCanPay') switchCanPay!: Function;
  @Action('changePayType') changePayType!: Function;
  @Action('changePayNumber') changePayNumber!: Function;
  @Action('changePayEditModal') changePayEditModal!: Function;

  type: string = getUrlParam('type') as string;
  radioList: Array<object> = [
    {
      value: '定金',
      label: '定金',
    },
    {
      value: '全额',
      label: '全额',
    },
  ];
  lessonTips: Tip = lessonTips;
  showTooltips: boolean = false;
  hasShowTooltips: boolean = false;
  throttle: Function = throttle;
  timer: any = null;
  instId: string = getUrlParam('instId') as string;
  orgId: string = getUrlParam('orgId') as string;
  fromApp: boolean = getUrlParam('enterType') === 'APP' || false;
  isCopy: boolean = getUrlParam('state') == 'copy';
  enterType: string = getUrlParam('enterType') as string;
  broadcastId: string = getUrlParam('broadcastId') as string;
  XMCounter: boolean = true;
  get payNumber(): number {
    return this.getterPayNumber;
  }

  set payNumber(val: number) {
    const payload: Payload = {
      number: val,
    };
    this.changePayNumber(payload);
  }

  mounted() {
    this.handleShowPayEditTootips();
    this.checkUserPermission();
  }

  handleShowPayEditTootips() {
    const id = getUrlParam('id');
    if (getUrlParam('type') === 'edit' && !window.localStorage.getItem(`template${id}`)) {
      window.localStorage.setItem(`template${id}`, 'true');
      const paySwitchContentDom = document.querySelector('.pay-switch-content') as HTMLDivElement;
      (paySwitchContentDom as any).io = setObserver('changePayEditModal', true);
      (paySwitchContentDom as any).io.observe(paySwitchContentDom);
    }
  }

  handleSwitch(status: boolean): void {
    if (this.xcxType === 'mkb') {
      return;
    }
    // 小程序制作的活动不支持支付
    if (this.xcxFlag) {
      Vue.$confirm({
        oneBtn: true,
        title: '提示',
        text: majorNoticeText,
        okText: '确定',
      });
      return;
    }
    if (this.type === 'edit') {
      if (this.instId && this.instId !== 'undefined' && (this.channel === 'XM_CASHIER' || this.isCopy || this.releaseStatus === '')) {
        fetch.Finance('anon/xmPay/getInstChannelStatus', { instId: this.instId }).then((res: any) => {
          const { wechatMiniOnlineStatus, xmPayRegisterStatusEnum } = res.result;
          // 未开通小麦收银
          if (xmPayRegisterStatusEnum !== 'SUCCESS') {
            Vue.$confirm({
              // oneBtn: true,
              title: '温馨提示',
              text: '小麦秀收款需开通小麦收银，且完成小麦收银-微信认证，如需收款请联系主账号前往小麦助教APP开通小麦收银',
              okText: this.fromApp ? '去开通' : '查看开通流程',
              ok: () => {
                if (this.fromApp) {
                  let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
                  if (xmPayRegisterStatusEnum === 'AUDIT_FAIL') {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/apply/result?status=fail&token=${getUrlParam('token')}&uid=${getUrlParam(
                      'uid'
                    )}&aid=${getUrlParam('aid')}&instId=${this.instId}&vn=${getUrlParam('vn') || getUrlParam('v')}`;
                  } else if (xmPayRegisterStatusEnum === 'AUDIT_PROGRESS') {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/apply/result?status=waiting&token=${getUrlParam('token')}&uid=${getUrlParam(
                      'uid'
                    )}&aid=${getUrlParam('aid')}&instId=${this.instId}&vn=${getUrlParam('vn') || getUrlParam('v')}`;
                  } else {
                    location.href =
                      'https://mp.weixin.qq.com/s?__biz=MzIxNDEyODIxMA==&mid=2654820994&idx=1&sn=f7ca68831e0dea08ceb689a5de468112&chksm=8c65b9bfbb1230a994aa2e4147fd96022dc39a66a30b5273c3980ea2cbfab7d44ae43b2e1823#rd';
                  }
                } else {
                  window.open(
                    'https://xopen.yuque.com/staff-sbg9na/xiaomai/anqyuggwzsnez3kr'
                  );
                }
                this.$emit("cancle");
              },
            });
          }else if (wechatMiniOnlineStatus !== 'AUTH_SUCCESS') {
            // 开通了小麦收银、没有完成微信认证
            Vue.$confirm({
              // oneBtn: true,
              title: '温馨提示',
              text: '当前未完成小麦收银微信认证,如需收款请完成【微信认证】。',
              okText: '前往认证',
              ok: () => {
                if (this.XMCounter) {
                  let env: string = process.env.VUE_APP_DEPLOY_ENV as string;
                  fetch.Finance('anon/xmPay/getInstChannelStatus', { instId: this.instId }).then((res: any) => {
                    location.href = `${(CONFIG.hybirdUrl as any)[env]}/finance/wechatNotice?channelStatusDetail=${JSON.stringify(res.result)}${
                      this.enterType ? `&enterType=${this.enterType}` : ''
                    }`;
                  });
                  parent.postMessage(
                    {
                      value: true,
                      action: 'linkToWechatNotice',
                    },
                    '*'
                  );
                } else {
                  Vue.$toast.error('无【小麦收银】权限，请联系管理员（主账号）');
                }
                this.$emit("cancle");
              },
            });
          } else {
            const payload: Payload = { status };
            this.switchCanPay(payload);
          }
        });
      }else  {
        const payload: Payload = { status };
        this.switchCanPay(payload);
      }
    }
  }
  checkUserPermission() {
    if (getUrlParam('instId') && getUrlParam('aid')) {
      const param = {
        instId: getUrlParam('instId'),
        adminId: getUrlParam('aid'),
        groupCode: 'XMCounter',
      };
      fetch.Sales('anon/inst/checkUserPermission', param).then((res: any) => {
        this.XMCounter = res.result;
      });
    } else {
      this.XMCounter = true;
    }
  }
  handleChangePayType(item: any): void {
    if (item.value !== this.payType && this.type === 'edit') {
      this.changePayType({ payType: item.value });
    }
  }

  handleInputBlur(value: number) {
    if (value < DECIMAL_MIN_NUM) {
      this.changePayNumber({ number: DECIMAL_MIN_NUM });
    }
    if (value > DECIMAL_MAX_NUM) {
      this.changePayNumber({ number: DECIMAL_MAX_NUM });
    }

    if (DECIMAL_MIN_NUM <= value && DECIMAL_MAX_NUM >= value) {
      const _value = Number(value).toFixed(2);
      this.changePayNumber({ number: _value });
    }
  }

  beforeDestroy() {
    window.clearTimeout(this.timer);
  }
}
